<template>
  <header :class="className" :style="style">
    <div class="header__content">
      <slot />
    </div>

    <div class="header__lead">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 243.7 39.4" class="header__lead-curve">
        <path fill-rule="evenodd" :d="path" />
      </svg>

      <button ref="scrollDownButton" class="header__lead-arrow" @click="onScrollDownClick" />
    </div>
  </header>
</template>

<script>
import scrollBoxParent from '@/extensions/scrollBoxParentMixin'

export default {
  name: 'ContentHeader',
  mixins: [scrollBoxParent],
  props: {
    image: { type: String, default: null },
    isHomepage: { type: Boolean, default: false },
    narrow: { type: Boolean, default: false }
  },
  computed: {
    style() {
      return this.image ? { backgroundImage: `url(${this.image})` } : {}
    },
    className() {
      return ['header', { '-homepage': this.isHomepage, '-narrow': this.narrow }]
    },
    path() {
      return this.isHomepage
        ? 'M120.86 39.39H0V0a103.91 103.91 0 0132 5.05A104.078 104.078 0 0160.93 19.7a103.994 103.994 0 0059.93 19.69zM243.71 0v39.39H122.86a104.002 104.002 0 0059.92-19.69A104 104 0 01243.71 0z'
        : 'M243.7 0a103.997 103.997 0 00-60.92 19.7c-36.372 26.26-85.478 26.26-121.85 0A104.074 104.074 0 000 0h243.7z'
    }
  },
  methods: {
    onScrollDownClick() {
      const { scrollDownButton } = this.$refs
      this.$scrollBoxParent.scrollToTarget(scrollDownButton, 400, -10)
    }
  }
}
</script>
